import {Mosaic} from "react-loading-indicators"

export default function OrbitProg () {
    return (
        <>
        <div className="mt-20">
        {/* <OrbitProgress variant="track-disc" color="#32cd32" size="small" text="loading" textColor="#0cc700" /> */}
        <Mosaic className="mt-aut" textColor="#aeaeaeff" text="loading" color={["#32cd32", "#327fcd", "#cd32cd", "#cd8032"]} />
        </div>
        </>
    )
}